<template>
  <div>
    <div class="complexion-check el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">If skin condition is</div>
      <el-select
        v-close-on-zoom
        placeholder="Select skin condition type"
        class="complexion-select"
        :disabled="readonly"
        :value="state.complexionType"
        @input="(id) => selectComplexion(id)"
      >
        <el-option
          v-for="value in complexions"
          :key="value.key"
          :label="value.label.en"
          :value="value.key"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

export default {
  name: 'complexion-check',
  props: [
    'states',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        complexionType: null,
      },
    };
  },
  computed: {
    complexions() {
      return sortBy(
        this.states.find(s => s.id === 'complexion').possibleValues, 
        value => value.label.en
      );
    },
  },
  beforeMount() {
    const data = this.getData(this.ikey);
    this.state.complexionType = get(data, 'value') || 'NORMAL',
    this.update();
  },
  methods: {
    selectComplexion(id) {
      this.state.complexionType = id;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'COMPLEXION',
        ids: [ 'FULL_BODY' ],
        operator: 'EQUAL',
        value: this.state.complexionType,
      });
      this.emitter.trigger('process', this.control);
    },
  },
}
</script>

<style scoped>

</style>